import { createElementBlock as e, openBlock as h, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(r, l) {
  return h(), e("svg", n, l[0] || (l[0] = [
    t("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M3.494 12.257h1.472l-.736-1.714zM24 9h-3.77l-.92.943L18.483 9h-8l-.736 1.543L9.011 9H5.793v.686L5.425 9H2.667L0 15h3.218l.368-.943h.92l.368.943H8.46v-.686l.276.686h1.839l.276-.771V15h7.356l.92-.943.827.943h3.77l-2.39-3zm-11.126 5.143h-1.012V10.8L10.3 14.143h-.92L7.816 10.8v3.343H5.701l-.368-.943H3.126l-.367.943H1.563l1.931-4.286h1.563l1.748 4.029V9.857h1.747l1.379 2.914 1.287-2.914h1.748v4.286zm9.103 0h-1.38l-1.195-1.457-1.379 1.457h-4.138V9.857h4.23l1.287 1.372 1.38-1.372h1.287L20.046 12zm-7.08-3.429v.772h2.298v.857h-2.298v.857h2.574l1.196-1.286-1.104-1.2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: o };
export {
  d as default,
  o as render
};
//# sourceMappingURL=ic_payment_amex_light-DYGJJL08.js.map
